import { ArrowRight, Box, Text } from '@doda/io-react/common';
import type { JobApplyResponse } from '@doda/api-client/aspida/@types';
import { convertHyphenToSlash } from '@doda/common/src/utils/dateUtil';
import styles from './index.module.scss';

/** 応募済みメッセージprops */
interface ApplyMessageProps {
  apply: JobApplyResponse;
  isAgent: boolean;
}

/** 応募済みメッセージ */
export const ApplyMessage = ({ apply, isAgent }: ApplyMessageProps) => {
  const appliedDate = convertHyphenToSlash(apply.appliedDate || '');
  return (
    <Box
      color="gray"
      radius="4"
      className={styles['jobSearchDetail-applyMessage']}
    >
      {isAgent ? (
        <Text as="p" color="black_pc" size="14--articlePC" weight="normal">
          {`この求人は、${appliedDate}にdodaエージェントサービスを通じて応募済みです`}
        </Text>
      ) : (
        <Text as="p" color="black_pc" size="20" weight="bold">
          {`この求人は、${appliedDate}に応募済みです`}
        </Text>
      )}
      {!isAgent && (
        <a
          href="/dcfront/history/historyList/"
          target="_blank"
          className={styles['jobSearchDetail-applyMessage__historyLink']}
        >
          <Text as="span" color="blue" size="14--articlePC" weight="normal">
            応募履歴を見る
          </Text>
          <ArrowRight color="blue" size="XS" />
        </a>
      )}
    </Box>
  );
};
